// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__xFNMn","inner":"style_inner__OMgW0","withSpinner":"style_withSpinner__fC4RV","footer":"style_footer__uPZ6g"};